<template>
  <div class="panel panel_content-top">
    <transition name="fade-height">
      <template v-if="isLazy">
        <div class="panel__content" v-show="isVisible">
          <slot name="content"></slot>
        </div>
      </template>
      <template v-else>
        <div class="panel__content" v-if="isVisible">
          <slot name="content"></slot>
        </div>
      </template>
    </transition>
    <div class="panel__head">
      <button
        type="button"
        class="btn btn-size-s btn-reports"
        @click="onClick"
      >
        {{showingTitle}}
        <div><i :class="arrow"></i></div>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportPanel',
  props: {
    isVisible: { type: Boolean, default: false },
    title: { type: String },
    isLazy: { type: Boolean, default: false }
  },
  data () {
    return {
      showingTitle: this.title || this.L10n('reports')
    }
  },
  computed: {
    arrow () {
      if (this.isVisible) {
        return 'el-icon-arrow-up'
      } else {
        return 'el-icon-arrow-down'
      }
    }
  },
  methods: {
    onClick () {
      this.$emit('update:isVisible', !this.isVisible)
    }
  }
}
</script>

<style lang="stylus">
.panel{
  margin-bottom .5rem
}
.panel__head{
  border-top 1px solid #e7e7e9
  display flex
  justify-content center
  align-items flex-end
}
.btn-reports{
  border-top-right-radius 0px !important
  border-top-left-radius 0px !important
}
.panel__tools{
  display flex
}
.panel__tools-item{
  display flex
  box-shadow 1px 1px 3px 0px rgba(0, 0, 0, .5)
  padding 1rem 2rem
  margin 1rem
  color #0B3A58
  font-weight bolder
  &.is-active-panel,
  &:hover{
    cursor pointer
    background #E6F1FB
  }
}
/*Position*/
.panel_content-top{

}
.fade-height-enter-active, .fade-height-leave-active {
  transition all 0.5s
  max-height 700px
  overflow hidden
}
.fade-height-enter, .fade-height-leave-to {
  opacity 0
  max-height 0px
}
</style>
